<ng-container *ngIf="employee">
  <div class="employee-initials rounded-circle in-the-middle placer-margin">
    <span
      *ngIf="!employee.user.profilePicture"
      [matTooltip]="
        employee.user?.firstName | personName: employee.user?.lastName
      "
      class="employee-initials-pending-block"
    >
      {{ employee.user?.firstName | initials: employee.user?.lastName }}
    </span>
    <span
      *ngIf="employee.user?.profilePicture"
      [matTooltip]="
        employee.user?.firstName | personName: employee.user?.lastName
      "
    >
      <img
        *ngIf="employee?.user?.profilePicture?.uuid"
        class="rounded-circle"
        width="30px"
        height="30px"
        [src]="'/api/assets/' + employee?.user?.profilePicture?.uuid + '/30'"
      />
    </span>
    <span
      class="mat-badge-content mat-badge-active status-badge black-svg-icon icon-margin"
      [matTooltip]="svgIcon | pendingStatusTooltip: locationVerification"
      [ngClass]="
        svgIcon == null || svgIcon === ''
          ? 'gray-background'
          : 'white-background'
      "
      [ngStyle]="{ 'border-color': borderColor }"
    >
      <mat-icon
        *ngIf="svgIcon != null && svgIcon !== ''"
        svgIcon="{{ svgIcon }}"
        class="smaller-icon mat-icon mat-icon-badge"
        [ngClass]="transformClass"
      ></mat-icon>
    </span>
  </div>
</ng-container>
<ng-container *ngIf="employee == null">
  <div class="employee-initials rounded-circle in-the-middle placer-margin">
    <span class="employee-initials-pending-block"></span>
    <span
      class="mat-badge-content mat-badge-active status-badge black-svg-icon icon-margin"
      [matTooltip]="svgIcon | pendingStatusTooltip: locationVerification"
      [ngClass]="
        icon == null || icon === '' ? 'gray-background' : 'white-background'
      "
      [ngStyle]="{ 'border-color': borderColor }"
    >
      <mat-icon
        *ngIf="svgIcon != null && svgIcon !== ''"
        svgIcon="{{ svgIcon }}"
        class="smaller-icon white-background mat-icon mat-icon-badge"
        [ngClass]="transformClass"
      ></mat-icon>
    </span>
  </div>
</ng-container>
